// ServicesHero.jsx
import React from 'react';
import { MoveRight } from 'lucide-react';

const ServicesHero = () => {
  return (
    <section className="w-full py-20 px-5 bg-white flex flex-col items-center text-center">
      {/* Google Font import via style tag or link in head */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@500&display=swap');
      `}</style>
      
      <div className="max-w-4xl mx-auto">
        {/* Main Heading - Playfair Display Serif Font */}
        <h1 
          className="text-5xl md:text-7xl text-[#1a202c] mb-8 tracking-tight"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Build. Automate. Scale.
        </h1>

        {/* Subtext - Default Sans Font */}
        <p className="text-lg md:text-xl text-slate-600 font-normal max-w-2xl mx-auto leading-relaxed mb-10">
          We help startups, creators, and businesses build digital products, 
          AI systems, and growth engines.
        </p>

        {/* Get Started Button */}
        <button className="bg-[#0f172a] hover:bg-black text-white px-8 py-4 rounded-xl font-semibold flex items-center gap-3 mx-auto transition-all duration-300 shadow-lg hover:shadow-xl">
          Get Started
          <MoveRight size={20} strokeWidth={2.5} />
        </button>
      </div>
    </section>
  );
};

export default ServicesHero;